import { render, staticRenderFns } from "./TableModel.vue?vue&type=template&id=ac0ac4ca&scoped=true&"
import script from "./TableModel.vue?vue&type=script&lang=ts&"
export * from "./TableModel.vue?vue&type=script&lang=ts&"
import style0 from "./TableModel.vue?vue&type=style&index=0&id=ac0ac4ca&lang=scss&scoped=true&"
import style1 from "./TableModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0ac4ca",
  null
  
)

export default component.exports